<template>
  <b-modal
    id="user-modal"
    :title="$t('user.add_new_user')"
    centered
    :ok-title="this.$t('save')"
    :cancel-title="this.$t('cancel')"
    cancel-variant="outline-secondary"
    ok-variant="success"
    size="lg"
    no-close-on-backdrop
    @ok="onSubmit"
    @show="clear"
    :ok-disabled="(user.password != user.password_confirm ? true : false)"
  >
    <validation-observer ref="newUserValidation">
      <b-form @submit.prevent id="new__user_add_modal">
        <b-row>



          <!-- ==============================  PHONE_NUMBER_INPUT START ============================== -->
          <b-col md="6">
            <b-form-group>
              <label>{{ $t("name") }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('name')"
                rules="required"
              >
                <b-form-input v-model="user.first_name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- ==============================  PHONE_NUMBER_INPUT START ============================== -->







          <!-- ==============================  PHONE_NUMBER_INPUT START ============================== -->
          <b-col md="6">
            <b-form-group>
              <label>{{ $t('user.surname') }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('user.surname')"
                rules="required"
              >
                <b-form-input v-model="user.last_name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- ==============================  PHONE_NUMBER_INPUT START ============================== -->





          
          <b-col md="6">
            <b-form-group>
              <label>{{ $t("user.login") }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('user.login')"
                rules="required"
              >
                <b-form-input v-model="user.username" autocomplete="off"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>


          <b-col class="col-md-6">
            <b-form-group>
              <label>{{ $t("role") }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('role')"
                rules="required"
              >
                <v-select
                  v-model="user.role"
                  multiple
                  class="bg-white rounded"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :get-option-label="
                    (el) => {
                      return el.name[$i18n.locale];
                    }
                  "
                  :reduce="(p) => p.id"
                  :options="GET_ROLE"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>


          <b-col cols="6">
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="v-password-new-user">
                  {{ $t("user.password") }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                :name="$t('user.password')"
                rules="required"
              >
                <!-- rules="required|min:4" -->
                <b-input-group
                  class="input-group-merge"
                >
                  <!-- :class="errors.length ? 'is-invalid' : null" -->
                  <b-form-input
                    id="v-password-new-user"
                    v-model="user.password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    name="v-password-new-user"
                    placeholder="············"
                    autocomplete="off"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>


          <b-col cols="6">
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="v-password-confirm-new-user">
                  {{ $t("user.password_confirm") }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                :name="$t('user.password_confirm')"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="!confirmPasswordBool ? 'is-invalid' : ''"
                >
                  <b-form-input
                    id="v-password-confirm-new-user"
                    v-model="user.password_confirm"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    name="v-password-confirm-new-user"
                    placeholder="············"
                    :class="!confirmPasswordBool ? 'is-invalid' : ''"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
/* eslint-disable */ 

import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BRow,
} from 'bootstrap-vue'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { min, required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match',
})

export default {
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BForm,
    BRow,
    BCol,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // =============== PRIMARY_DATA START ===============
      min,
      required,
      user: {
        username: '',
        first_name: '',
        last_name: '',
        role: null,
        password: '',
        password_confirm: '',
      },
      // =============== PRIMARY_DATA END ===============




      // =============== PRIMARY_DATA START ===============
      confirmPasswordBool: true
      // =============== PRIMARY_DATA END ===============
    }
  },
  watch: {
    user: {
      handler: function (val, oldVal) {
        if(val.password != val.password_confirm){
          this.confirmPasswordBool = false
        }else{
          this.confirmPasswordBool = true
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('users', ['GET_USERS']),
    ...mapGetters('role', ['GET_ROLE']),


    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    








  },

  async mounted() {
    await this.FETCH_ROLE()
  },


  methods: {
    ...mapActions('users', ['FETCH_USERS', 'CREATE_USER']),
    ...mapActions('role', ['FETCH_ROLE']),

    





    






    // =============== ON_SUBMIT START ===============
    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.newUserValidation.validate().then(async success => {
        if (!success) {
          return
        }

        try {
          delete this.user.password_confirm
          await this.CREATE_USER(this.user)

          this.$_okToast('Success')

          this.$nextTick(() => {
            this.$bvModal.hide('user-modal')
            this.clear()
          })

          this.FETCH_USERS()
        } catch (ex) {
          if(Object.keys(ex.response.data).includes('username')){
            this.$_errToast({message: this.$t('such_a_user_exists')})
          }else if(Object.keys(ex.response.data).includes('fname-error') && Object.keys(ex.response.data).includes('lname-error')){
            this.$_errToast({message: this.$t('it_is_not_possible_to_enter_a_number_in_the_field_name_and_surname')})
          }else if(Object.keys(ex.response.data).includes('fname-error')){
            this.$_errToast({message: this.$t('it_is_not_possible_to_enter_a_number_in_the_field_name')})
          }else if(Object.keys(ex.response.data).includes('lname-error')){
            this.$_errToast({message: this.$t('it_is_not_possible_to_enter_a_number_in_the_field_surname')})
          }else{
            this.$_errToast('Error')
          }
        }
      })
    },
    // =============== ON_SUBMIT END ===============













   
    // =============== CLEAR_FUNC START ===============
    clear() {
      this.user = {
        password: '',
        username: '',
        first_name: '',
        last_name: '',
        role: null,
      }
    },
    // =============== CLEAR_FUNC END ===============


















  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

</style>
